import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'
export default function SoftwarePageIndex(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Software Testing & Quality Assurance Services - Infograins</title>
                <meta name="description" content="Infograins employs a cutting-edge methodology for application and software testing services to lower risk, advance quality control, and enhance IT performance." />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <ContentDiv />
        </>
    )
}
